import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {deleteUserForCustomer, deleteUserForCustomerInvite, fetchUsersForCustomer} from "../../../actions";
import {bbFormattedDateString, isCurrentUserMemberOf} from "../../../util/bbHelpers";
import BBDataTable from "../tables/BBDataTable";
import {BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import {renderCellExpand} from "../tables/DataGridRenderCellExpand";
import UpdateSenderNameWidget
    from "../admin/AdminSocialComponents/UpdateSocialTemplateComponentsForTable/UpdateSenderNameWidget";
import CloseIcon from "@material-ui/icons/Close";
import {IconButton} from "@mui/material";
import NewUserFormUserManagementTable from "./NewUserFormUserManagementTable";
import BBIconCheck from "../../../assets/bbCustomIcons/BBIconCheck";
import BBIconRoundedDashNull from "../../../assets/bbCustomIcons/BBIconRoundedDashNull";
import {HashLink as Link} from "react-router-hash-link";

const UserManagementTableForCustomers = ({props})=>{
    const {customers, customerInView, loadingUsersForCustomer, loadingUsersForCustomerError,
        loadingCreateUserForCustomer, loadingCreateUserForCustomerError, loadingDeleteUserForCustomer, loadingDeleteUserForCustomerError} = useSelector(({customer}) => customer);
    const authUser = useSelector(({auth}) => auth.authUser);
    const {didJustAddUser, didJustDeleteUser} = useSelector(({customer})=>customer.appMisc);
    const customer = customers ? customerInView ? customers[customerInView] : null : null;
    const customerIdToUse = customers ? customerInView ? customerInView : null : null;

    const dispatch = useDispatch();

    const usersForCustomer = customer && customer.users;

    const authUserCustomerArray = authUser && authUser.customers && Array.isArray(authUser.customers)
        ? authUser.customers
        : null;

    const userCustomerObjectInView = authUserCustomerArray
        && authUserCustomerArray.find((customer)=> customer.customer === customerInView)

    const authUserIsManager = userCustomerObjectInView && userCustomerObjectInView.manager;

    const isStaffAdmin = isCurrentUserMemberOf(authUser, "admin") || isCurrentUserMemberOf(authUser, "staff");

    useEffect(()=>{
        if((authUserIsManager || isStaffAdmin)
            && customer
            && customerIdToUse
            && !usersForCustomer
            && !loadingUsersForCustomer[customerIdToUse]
            && !loadingUsersForCustomerError[customerIdToUse]){
            dispatch(fetchUsersForCustomer({
                customerId: customerIdToUse}
            ))
        }
    }, [customer, customerInView, customerIdToUse ,loadingCreateUserForCustomer, loadingDeleteUserForCustomerError, loadingCreateUserForCustomer, usersForCustomer])

    // useEffect(()=>{
    //     if(didJustAddUser || didJustDeleteUser){
    //         dispatch(fetchUsersForCustomer({
    //             customerId: customerIdToUse}
    //         ))
    //     }
    // },[didJustAddUser, didJustDeleteUser])
        //The add and delete calls return the full users array, shouldn't need to update users again. Should correctly update state in calls

    const title = <div id={"UserManagementTable"}>
        User Management <Tooltip title={"Manage access to your company's account. "}>
        <InfoSharpIcon style={{fontSize: "smaller"}} className={``}/>
    </Tooltip>
    </div>;

    const usersArray = usersForCustomer && usersForCustomer.users ? usersForCustomer.users : null;
    const invitationsArray = usersForCustomer && usersForCustomer.invitations ? usersForCustomer.invitations : null;

    const numUsers = usersArray && invitationsArray ? usersArray.length + invitationsArray.length : 0;

    const tableData = usersArray && invitationsArray ? usersArray.concat(invitationsArray).map((user)=>{

        const userIsInviteOnly = !user.user;
        // console.log("userISInvitenly", userIsInviteOnly, )
        return {
            ...user,
            isInviteOnly: userIsInviteOnly,
            firstName: userIsInviteOnly ? user.first_name : user.user.first_name,
            lastName: userIsInviteOnly ? user.last_name : user.user.last_name,
            email: userIsInviteOnly ? user.email : user.user.email,
            isManager: userIsInviteOnly ? user.manager : user.manager,
            addedBy: userIsInviteOnly ? null : user.added_by,
            dateAdded: userIsInviteOnly ? null : user.added_datetime,
        }
    })
    : null;

    console.log("users for customers", usersForCustomer, "loading", loadingUsersForCustomer, "error", loadingUsersForCustomerError, "usersArray", usersArray, "invivitationsArray", invitationsArray, "tableData", tableData);

    const handleClick = (idToDelete, isInviteOnly) =>{
        console.log("idToDelete", idToDelete, "isINviteOnly", isInviteOnly)
        if(isInviteOnly){
            dispatch(deleteUserForCustomerInvite(customerInView, idToDelete))
        } else{
            dispatch(deleteUserForCustomer(customerInView, idToDelete))
        }
    }

    const columns = [
        { field: "id", headerName: "ID", hide: true, flex: 1, sortable: false, renderCell: (params)=>
                renderCellExpand(params, (
                    <span>
               {params.value}
           </span>
                ))},
        { field: "firstName", headerName: "First Name", hide: false, flex: 1, sortable: false, renderCell: (params)=>
                renderCellExpand(params, (
                    <span>
               {params.value ? params.value : "--"}
           </span>
                ))},
        { field: "lastName", headerName: "Last Name", hide: false, flex: 1, sortable: false, renderCell: (params)=>
                renderCellExpand(params, (
                    <span>
               {params.value ? params.value : "--"}
           </span>
                ))},
        { field: "email", headerName: "Email", hide: false, flex: 1.5, sortable: false, renderCell: (params)=>
                renderCellExpand(params, (
                    <code>
               {params.value ? params.value : "--"}
           </code>
                ))},
        { field: "isManager", headerName: " Manager", hide: false, flex: .5, sortable: true, renderCell: (params)=>
                renderCellExpand(params, (
                    <div>
               {params.value ? <BBIconCheck style={{fontSize: "1rem"}}/> : <BBIconRoundedDashNull style={{fontSize: "1rem"}}/>}
           </div>
                ))},
        { field: "addedBy", headerName: "Added By", hide: false, flex: 1, sortable: false, renderCell: (params)=>
                renderCellExpand(params, (
                    <span>
               {params.value ? params.value : "pending"}
           </span>
                ))},
        { field: "dateAdded", headerName: "Added On", hide: false, flex: 1, sortable: true, renderCell: (params)=>
                renderCellExpand(params, (
                    <span>
               {params.value ? bbFormattedDateString(params.value, "shortFullMonth") : "pending"}
           </span>
                ))},
        { field: "action", headerName: "Delete", hide: false, sortable: false, renderCell: (params)=>
                renderCellExpand(params, (
                    <span className={"text-center"}>
               <IconButton onClick={()=>handleClick(params.row.id, params.row.isInviteOnly)}>
                   <CloseIcon/>
               </IconButton>
           </span>
                ))},
    ]

    const description = <span className={"m-0 p-0"}>
        <p className={"m-0 p-0"}><em></em> Invite or remove users from within your company to use the BreachRisk&trade; dashboard. To allow access to your BreachRisk&trade; Score or Report for users outside of your company, please visit the <Link to={'/board/BreachRisk/Business/Share/Current'}>Data Sharing page.</Link></p>
    </span>

    return(
        <div>
            {usersForCustomer
                ?
                <BBDataTable
                    columns={columns}
                    rows={tableData}
                    title={title}
                    topRightElement={<NewUserFormUserManagementTable/>}
                    progressValue={100}
                    // bufferValue={(numCampaigns + 1) / customersArr.length * 100}
                    loading={false}
                    defaultPageSize={10}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    description={description}
                    isActiveSubscriptionRequiredToUse={false}
                >
                </BBDataTable>
                :
                <BBDataTable
                    columns={columns}
                    rows={[]}
                    title={title}
                    loading={false}
                    description={description}
                    isActiveSubscriptionRequiredToUse={false}
                >

                </BBDataTable>
            }

        </div>
    )
}

export default UserManagementTableForCustomers;